import { Component, inject, computed, input } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { IconNameType } from '../../icons/icon-name-type.enum';
import { PremiumService } from '../../../loyalty/premium/premium.service';
import { RoundIconComponent } from '../../round-icon/round-icon.component';
import { CurrencyPipe } from '@angular/common';
import { LoyaltySubscription } from '../../../core/models/loyalty/loyalty-subscription.model';

@Component({
  selector: 'cwo-plan-premium-single',
  imports: [TranslocoDirective, RoundIconComponent, CurrencyPipe],
  templateUrl: './plan-premium-single.component.html',
  styleUrl: './plan-premium-single.component.scss',
})
export class PlanPremiumSingleComponent {
  readonly plan = input.required<LoyaltySubscription>();
  private readonly premiumService = inject(PremiumService);
  readonly IconNameType = IconNameType;
  readonly planPerks = computed(() =>
    this.premiumService.perksForPlan(this.plan().subscriptionName ?? this.plan().displayName ?? ''),
  );

  readonly planPricing = computed(() => {
    const plan = this.plan();
    const monthly = plan?.monthlyPrice?.price ?? 0;
    if (monthly > 0) {
      return { amount: monthly / 100, periodKey: 'modals.premium_promo.per_month' };
    }
    return { amount: (plan?.annualPrice?.price ?? 0) / 100, periodKey: 'modals.premium_promo.per_year' };
  });

}